import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PRIVATE_ROUTES } from '../constants/app.constants';

export const PublicGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // usuario no logueado o token caducado -> puede entrar
    if (!auth.isUserLoggedIn()) {
        return true;
    }

    // Redirigir según tenga rol o no
    const token = auth.getDecodedToken();

    // usuario logueado + no tiene rol --> regirige al registro Específico para que complete el registro donde se asigna un rol
    if (!token.role) {
        return router.createUrlTree([`/${PRIVATE_ROUTES.specificSignIn}`]);
    }

    // usuario logueado + tiene rol --> redirigimos al calendario
    return router.createUrlTree([auth.homeRoute()]);
};
